import { isFuture, differenceInYears } from 'date-fns'
import {
  required, between, minLength, minValue,
} from 'vuelidate/lib/validators'

/* eslint-disable camelcase */
function getBirthAndLicenseDates(component) {
  const { birthday, licence_date } = component.form

  return { birthday: birthday?.custom, licence_date: licence_date?.custom }
}

export default {
  day: {
    required,
    minLength: minLength(2),
    between: between(1, 31),
  },
  month: {
    required,
    minLength: minLength(2),
    between: between(1, 12),
  },
  year: {
    required,
    minValue: minValue(new Date().getFullYear() - 100),
    minLength: minLength(4),
  },
  custom: {
    required,
    minLength: minLength(10),

    timeCoherence(value) {
      const valueDate = new Date(value)
      let { birthday, licence_date } = getBirthAndLicenseDates(this)

      if (!birthday || !licence_date) {
        return true
      }

      birthday = new Date(birthday)
      licence_date = new Date(licence_date)

      if (
        (isFuture(valueDate))
        || (differenceInYears(licence_date, birthday) < 18)
      ) {
        return false
      }
      return true
    },
  },
}
/* eslint-enable camelcase */
